import { Nullable } from '@/interfaces/Nullable';

export const queryKeys = {
  bill: (
    params:
      | {
          outletId: Nullable<string>;
          tableNumber?: string;
          amount?: number;
          selectedTipPercentage?: number;
          locale?: string;
        }
      | undefined
  ) => ['bill', params],
  outletKitchen: (params: { outletId: Nullable<string> }) => ['outletKitchen', params],
  kitchenLink: (params: { brandId: string; kitchenId: string }) => ['kitchenLink', params],
  brand: (params: { brandId: Nullable<string> }) => ['brand', params],
  paymentStatus: (params: { guestId: string; paymentId: Nullable<string> }) => [
    'paymentStatus',
    params,
  ],
  intentStatus: (params: { intentId: string }) => ['intentStatus', params],
  postPayment: 'postPayment',
  postGooglePay: 'postGooglePay',
  postApplePay: 'postApplePay',
  validateApplePayMerchant: 'validateApplePayMerchant',
  splitDetails: (params: { orderNumber: string }) => ['splitDetails', params],
  paymentSummary: (params: { orderNumber: string }) => ['paymentSummary', params],
  customerCheckIn: (params: { outletId: string; tableNumber: string; customerId: string }) => [
    'customerCheckIn',
    params,
  ],
  branchMenus: (params: {
    brandId: string;
    kitchenId: string;
    pointOfSaleId: string;
    language: string;
  }) => ['branchMenus', params],
  branchConfiguration: (params: { brandId?: string; outletId?: string }) => [
    'branchConfiguration',
    params,
  ],
};
